import { createFileRoute } from '@tanstack/react-router'

import WriteAdminKecamatan from '@/components/pages/backoffice/_user/_bpp/containers/WriteAdminKecamatan'

export const Route = createFileRoute('/_backoffice/user/bpp/$adminId/edit')({
  component: AdminKecamatanEditPage
})

function AdminKecamatanEditPage() {
  const { adminId } = Route.useParams()

  return <WriteAdminKecamatan type="edit" userId={adminId} />
}
